import React from 'react';
import Shop4 from '../../components/ShopElements/Shop4';
import PageHeader from '../Shared/PageHeader';

const Shop4Col = () => {
    return (
        <div>
            <PageHeader title="Shop" />
            <Shop4 />
        </div>
    );
};

export default Shop4Col;